module.exports = __webpack_public_path__ + "4673fe7efb60cd3e3a1906285ecab0b1.png";